<div class="container-fluid p-0 m-0">
  <div class="card border-0 p-0 m-0">
    <div class="card-header bg-red">
      <div class="closebtn" (click)="dismiss()"><span class="material-symbols-outlined font-weight-bold"> close  </span></div>
      <div class="d-flex">
        <div class="bellicon"> <img src="/assets/icons/warning.png" >  </div>
        <div>Beware Of Phishing Websites Before Login. Enable Security Auth To Secure Your ID.</div>
      </div>
    </div>
    <div class="card-body p-0">
      <img style="height: 300px; width: 100%;" src="{{popupImg}}" alt="popup">
    </div>
  </div>
</div>
